/* ==========================================================================
   NUBORI — Interacciones
   Vanilla, sin librerías. Un solo IntersectionObserver compartido.
   Cada init comprueba que su elemento existe, así el archivo sirve
   para todas las páginas.
   ========================================================================== */

(function () {
  'use strict';

  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function mostrarTodo() {
    document.querySelectorAll('.nb-reveal').forEach(function (el) {
      el.classList.add('nb-visible');
    });
  }

  /* ---- Reveals al entrar en pantalla ----------------------------------
     Red de seguridad: si no hay IntersectionObserver, si el sistema pide
     no animar, o si por lo que sea el observador no ha disparado en 2,5 s
     (p. ej. la pestaña cargó en segundo plano), se muestra todo. Nunca
     debe quedarse la página en blanco.                                    */
  function initReveals() {
    var elementos = document.querySelectorAll('.nb-reveal');
    if (!elementos.length) return;

    if (sinMovimiento || !('IntersectionObserver' in window)) {
      mostrarTodo();
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('nb-visible');
          observador.unobserve(entrada.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    elementos.forEach(function (el) {
      observador.observe(el);
    });

    // Salvavidas: si nada se ha revelado, no lo escondemos para siempre.
    setTimeout(function () {
      if (!document.querySelector('.nb-reveal.nb-visible')) mostrarTodo();
    }, 2500);
  }

  /* ---- Escalonado automático dentro de un grupo ------------------------ */
  function initStagger() {
    var grupos = document.querySelectorAll('[data-nb-stagger]');
    if (!grupos.length) return;

    grupos.forEach(function (grupo) {
      var paso = parseInt(grupo.getAttribute('data-nb-stagger'), 10) || 90;
      var hijos = grupo.querySelectorAll('.nb-reveal');
      hijos.forEach(function (hijo, i) {
        hijo.style.setProperty('--nb-delay', i * paso + 'ms');
      });
    });
  }

  /* ---- Cifras que cuentan al aparecer --------------------------------- */
  function initContadores() {
    var cifras = document.querySelectorAll('[data-nb-contador]');
    if (!cifras.length) return;

    if (sinMovimiento || !('IntersectionObserver' in window)) {
      cifras.forEach(function (el) {
        el.textContent = el.getAttribute('data-nb-contador');
      });
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          contar(entrada.target);
          observador.unobserve(entrada.target);
        });
      },
      { threshold: 0.5 }
    );

    cifras.forEach(function (el) {
      observador.observe(el);
    });

    function contar(el) {
      var destinoTexto = el.getAttribute('data-nb-contador') || '';
      var destino = parseFloat(destinoTexto.replace(/[^\d.]/g, ''));
      if (isNaN(destino)) {
        el.textContent = destinoTexto;
        return;
      }
      var sufijo = destinoTexto.replace(/[\d.,\s]/g, '');
      var duracion = 1500;
      var inicio = null;

      function paso(ahora) {
        if (!inicio) inicio = ahora;
        var t = Math.min((ahora - inicio) / duracion, 1);
        var eased = 1 - Math.pow(1 - t, 3);
        var valor = destino * eased;
        var mostrado = destino % 1 === 0 ? Math.round(valor) : valor.toFixed(1);
        el.textContent = mostrado + sufijo;
        if (t < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
  }

  /* ---- Preguntas frecuentes (acordeón accesible) ---------------------- */
  function initFaq() {
    var preguntas = document.querySelectorAll('.nb-faq__pregunta');
    if (!preguntas.length) return;

    preguntas.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var item = boton.closest('.nb-faq__item');
        if (!item) return;
        var abierto = item.classList.contains('nb-abierto');
        var lista = boton.closest('.nb-faq');

        if (lista && lista.getAttribute('data-nb-solo-uno') === 'true') {
          lista.querySelectorAll('.nb-faq__item.nb-abierto').forEach(function (otro) {
            if (otro === item) return;
            otro.classList.remove('nb-abierto');
            var b = otro.querySelector('.nb-faq__pregunta');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }

        item.classList.toggle('nb-abierto', !abierto);
        boton.setAttribute('aria-expanded', String(!abierto));
      });
    });
  }

  /* ---- Galería de la página de producto ------------------------------- */
  function initGaleria() {
    var galerias = document.querySelectorAll('[data-nb-galeria]');
    if (!galerias.length) return;

    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-nb-galeria-principal]');
      var miniaturas = galeria.querySelectorAll('[data-nb-miniatura]');
      if (!principal || !miniaturas.length) return;

      miniaturas.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-nb-miniatura');
          var alt = mini.getAttribute('data-nb-alt') || '';
          if (!src) return;
          principal.src = src;
          principal.alt = alt;
          miniaturas.forEach(function (m) {
            m.classList.remove('nb-activa');
            m.setAttribute('aria-current', 'false');
          });
          mini.classList.add('nb-activa');
          mini.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ---- Selector de variantes ------------------------------------------
     Soporta varias opciones a la vez (p. ej. Color + Talla). Al cambiar
     cualquiera, busca la variante que case con TODAS las opciones elegidas
     y actualiza precio, id del formulario, disponibilidad y foto.          */
  function initVariantes() {
    var bloques = document.querySelectorAll('[data-nb-producto]');
    if (!bloques.length) return;

    bloques.forEach(function (bloque) {
      var datos = bloque.querySelector('[data-nb-variantes-json]');
      var campoId = bloque.querySelector('[data-nb-id-variante]');
      if (!datos || !campoId) return;

      var variantes;
      try {
        variantes = JSON.parse(datos.textContent);
      } catch (e) {
        return;
      }
      if (!variantes || !variantes.length) return;

      var selectores = bloque.querySelectorAll('[data-nb-opcion]');
      var precio = bloque.querySelector('[data-nb-precio]');
      var precioAntes = bloque.querySelector('[data-nb-precio-antes]');
      var ahorroCaja = bloque.querySelector('[data-nb-ahorro]');
      var ahorroNum = bloque.querySelector('[data-nb-ahorro-num]');
      var ofertaCaja = bloque.querySelector('[data-nb-cuenta-atras]');
      var stockCaja = bloque.querySelector('[data-nb-stock]');
      var stockNum = bloque.querySelector('[data-nb-stock-num]');
      var stockUmbral = parseInt((stockCaja && stockCaja.getAttribute('data-nb-umbral')) || '8', 10);
      var boton = bloque.querySelector('[data-nb-anadir]');
      var aviso = bloque.querySelector('[data-nb-aviso-variante]');
      var principal = bloque.querySelector('[data-nb-galeria-principal]');
      if (!selectores.length) return;

      function elegidas() {
        return Array.prototype.map.call(selectores, function (s) {
          return s.value;
        });
      }

      function buscar() {
        var sel = elegidas();
        for (var i = 0; i < variantes.length; i++) {
          var v = variantes[i];
          var casa = true;
          for (var j = 0; j < sel.length; j++) {
            if (v.opciones[j] !== sel[j]) {
              casa = false;
              break;
            }
          }
          if (casa) return v;
        }
        return null;
      }

      function pintarEtiqueta(selector) {
        var etiqueta = selector.parentNode.querySelector('[data-nb-valor-opcion]');
        if (etiqueta) etiqueta.textContent = selector.value;
      }

      function actualizar() {
        Array.prototype.forEach.call(selectores, pintarEtiqueta);
        var v = buscar();

        if (!v) {
          if (boton) {
            boton.disabled = true;
            boton.textContent = 'No disponible';
          }
          if (aviso) aviso.hidden = false;
          return;
        }
        if (aviso) aviso.hidden = true;

        campoId.value = v.id;

        if (precio) precio.innerHTML = v.precio;
        if (precioAntes) {
          if (v.precioAntes) {
            precioAntes.innerHTML = v.precioAntes;
            precioAntes.hidden = false;
          } else {
            precioAntes.hidden = true;
          }
        }
        if (ahorroCaja) {
          if (v.precioAntes && v.ahorroPct) {
            if (ahorroNum) ahorroNum.textContent = v.ahorroPct;
            ahorroCaja.hidden = false;
          } else {
            ahorroCaja.hidden = true;
          }
        }
        // La oferta (contador) solo tiene sentido si ESTA variante concreta
        // tiene de verdad un precio anterior más alto que el actual.
        if (ofertaCaja) ofertaCaja.hidden = !(v.precioAntes && v.ahorroPct);

        if (stockCaja) {
          var cantidad = typeof v.stock === 'number' ? v.stock : null;
          if (cantidad === null || cantidad <= 0) {
            stockCaja.hidden = true;
          } else {
            stockCaja.hidden = false;
            var urgente = cantidad <= stockUmbral;
            stockCaja.classList.toggle('nb-prod__stock--urgente', urgente);
            if (stockNum) stockNum.textContent = cantidad;
            // Reconstruimos el texto entero para respetar el número resaltado.
            stockCaja.innerHTML = urgente
              ? '¡Quedan solo <span data-nb-stock-num>' + cantidad + '</span> unidades!'
              : 'En stock — <span data-nb-stock-num>' + cantidad + '</span> disponibles';
          }
        }

        if (boton) {
          boton.disabled = !v.disponible;
          boton.textContent = v.disponible
            ? boton.getAttribute('data-texto') || 'Añadir al carrito'
            : 'Agotado';
        }

        if (principal && v.imagen) {
          principal.src = v.imagen;
          bloque.querySelectorAll('[data-nb-miniatura]').forEach(function (m) {
            var activa = m.getAttribute('data-nb-miniatura') === v.imagen;
            m.classList.toggle('nb-activa', activa);
            m.setAttribute('aria-current', String(activa));
          });
        }

        // Refleja la variante en la URL, como hace Shopify.
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      Array.prototype.forEach.call(selectores, function (s) {
        s.addEventListener('change', actualizar);
        pintarEtiqueta(s);
      });
    });
  }

  /* ---- Cuenta atrás de ofertas reales ----------------------------------
     Cuenta contra una fecha real (data-fin). Es solo el reloj visual: la
     protección de verdad es que el precio anterior desaparece del propio
     producto cuando la oferta termina (lo hace la tienda, no este script).
     Si la fecha ya pasó, se oculta el bloque entero en vez de mostrar
     "00:00:00" indefinidamente.                                            */
  function initCuentaAtras() {
    var cajas = document.querySelectorAll('[data-nb-cuenta-atras]');
    if (!cajas.length) return;

    function actualizarTodas() {
      var ahora = Date.now();
      cajas.forEach(function (caja) {
        if (caja.hidden) return;
        var reloj = caja.querySelector('[data-nb-reloj]');
        if (!reloj) return;
        var fin = new Date(caja.getAttribute('data-fin')).getTime();
        if (isNaN(fin)) {
          caja.hidden = true;
          return;
        }
        var restante = fin - ahora;
        if (restante <= 0) {
          caja.hidden = true;
          return;
        }
        var dias = Math.floor(restante / 86400000);
        var horas = Math.floor((restante % 86400000) / 3600000);
        var minutos = Math.floor((restante % 3600000) / 60000);
        var segundos = Math.floor((restante % 60000) / 1000);
        var partes = [];
        if (dias > 0) partes.push(dias + 'd');
        partes.push(String(horas).padStart(2, '0') + 'h');
        partes.push(String(minutos).padStart(2, '0') + 'm');
        if (dias === 0) partes.push(String(segundos).padStart(2, '0') + 's');
        reloj.textContent = partes.join(' ');
      });
    }

    // Si el editor de Shopify reinicializa la página, no acumular relojes.
    if (window.__nbIntervaloOferta) clearInterval(window.__nbIntervaloOferta);
    actualizarTodas();
    window.__nbIntervaloOferta = setInterval(actualizarTodas, 1000);
  }

  /* ---- Arranque ------------------------------------------------------- */
  function iniciar() {
    initStagger();
    initReveals();
    initContadores();
    initFaq();
    initGaleria();
    initVariantes();
    initCuentaAtras();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  // El editor de Shopify recarga secciones sueltas: re-inicializa.
  document.addEventListener('shopify:section:load', iniciar);
})();
